"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeSupportSelectors = exports.handleComponentWithoutChildrenClassNames = exports.handleComponentClassName = exports.handleComponentChildrenClassNames = void 0;
var _generateClassName = _interopRequireDefault(require("../generateClassName"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var handleComponentClassName = exports.handleComponentClassName = function handleComponentClassName(allClassNames, component, componentKeySplit) {
  return _objectSpread(_objectSpread({}, allClassNames), (0, _generateClassName["default"])({
    component: component,
    componentKeySplit: componentKeySplit
  }));
};
var handleComponentWithModifiersClassName = function handleComponentWithModifiersClassName(component, componentKeySplit, modifiers) {
  return _objectSpread({}, (0, _generateClassName["default"])({
    component: component,
    componentKeySplit: componentKeySplit,
    modifiers: modifiers
  }));
};
var handleComponentKeySplit = function handleComponentKeySplit(component, componentKeySplit) {
  return (0, _generateClassName["default"])({
    component: component,
    componentKeySplit: componentKeySplit
  });
};
var isChildName = function isChildName(child) {
  return typeof child === 'string';
};
var handleComponentChildrenClassNames = exports.handleComponentChildrenClassNames = function handleComponentChildrenClassNames(component, children, modifiers, generateComponentClassNames) {
  return children.reduce(function (generatedClassNames, currentChild) {
    var componentClassName;
    if (currentChild && currentChild !== null && currentChild !== void 0 && currentChild.component) {
      componentClassName = generateComponentClassNames(_objectSpread(_objectSpread({}, currentChild), {}, {
        component: "".concat(component, "-").concat(currentChild === null || currentChild === void 0 ? void 0 : currentChild.component)
      }));
    } else {
      if (currentChild !== null && currentChild !== void 0 && currentChild.child) {
        componentClassName = (0, _generateClassName["default"])(_objectSpread({
          component: component,
          child: currentChild === null || currentChild === void 0 ? void 0 : currentChild.child
        }, currentChild));
      }
      if (isChildName(currentChild)) {
        componentClassName = (0, _generateClassName["default"])({
          component: component,
          child: currentChild,
          modifiers: modifiers
        });
      }
    }
    return _objectSpread(_objectSpread({}, generatedClassNames), componentClassName);
  }, {});
};
var handleComponentWithoutChildrenClassNames = exports.handleComponentWithoutChildrenClassNames = function handleComponentWithoutChildrenClassNames(component, componentKeySplit, modifiers) {
  var componentWithoutChildrenClassNames;
  componentWithoutChildrenClassNames = handleComponentKeySplit(component, componentKeySplit);
  if (modifiers) {
    componentWithoutChildrenClassNames = handleComponentWithModifiersClassName(component, componentKeySplit, modifiers);
  }
  return componentWithoutChildrenClassNames;
};
var mergeSupportSelectors = exports.mergeSupportSelectors = function mergeSupportSelectors(allClassNames, supportSelectors) {
  return supportSelectors.reduce(function (allClassNamesWithSupports, currentSupportSelectorGroup) {
    return _objectSpread(_objectSpread({}, allClassNamesWithSupports), currentSupportSelectorGroup);
  }, allClassNames);
};